import { ParameterType } from './../parameter-type.enum';
import { HttpHeaders } from '@angular/common/http';

export class HeadersBuilder {
  private headers = new HttpHeaders();
  public addContentType(type: ParameterType): HeadersBuilder {
    switch (type) {
      case ParameterType.Json:
        this.headers = this.headers.set('Content-Type', 'application/json');
        break;
      case ParameterType.FormUrlEncoded:
        this.headers = this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
        break;
      default:
        throw Error('Unknown parameter type');
    }
    return this;
  }
  public addJwt(jwt: string | undefined): HeadersBuilder {
    if (!jwt) {
      return this;
    }
    this.headers = this.headers.set('Authorization', `Bearer ${jwt}`);
    return this;
  }
  public get(): HttpHeaders {
    return this.headers;
  }
}
